import React from 'react';
import { Clock } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="py-12 px-4 bg-red-50 border-y border-red-100" data-id="element-242">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-243">
        <Clock className="w-16 h-16 text-red-600 mb-4 animate-pulse" data-id="element-244" />
        <h2 className="text-2xl md:text-3xl font-black text-red-700 mb-6 uppercase tracking-wide" data-id="element-245">
          OFFERTA SPECIALE A TEMPO LIMITATO
        </h2>
        <CountdownTimer variant="red" size="lg" data-id="element-246" />
      </div>
    </section>;
}